import { render } from "./OtherTalent.vue?vue&type=template&id=5fd5b055&ts=true&lang=pug"
import script from "./OtherTalent.vue?vue&type=script&lang=ts"
export * from "./OtherTalent.vue?vue&type=script&lang=ts"

import "./OtherTalent.vue?vue&type=style&index=0&id=5fd5b055&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__